module.exports = __webpack_public_path__ + "static/media/Behkana.fece73cb.jpg";